import { render } from "./DashboardReportings.vue?vue&type=template&id=ef87dd7c&scoped=true"
import script from "./DashboardReportings.vue?vue&type=script&lang=js"
export * from "./DashboardReportings.vue?vue&type=script&lang=js"

import "./DashboardReportings.vue?vue&type=style&index=0&id=ef87dd7c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef87dd7c"]])

export default __exports__